import { render } from "./color-pane.vue?vue&type=template&id=7a106f2c&scoped=true&ts=true"
import script from "./color-pane.vue?vue&type=script&lang=ts"
export * from "./color-pane.vue?vue&type=script&lang=ts"

import "./color-pane.vue?vue&type=style&index=0&id=7a106f2c&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a106f2c"]])

export default __exports__